enum EndorsementEligibilityStatusType {
	INACTIVE_POLICY = 'Inactive Policy',
	RENEWAL_PERIOD = 'Renewal Period',
	ELIGIBLE = 'Eligible',
	ENDORSEMENT_IN_PROGRESS = 'Endorsement in Progress',
	ENDORSEMENT_SUBMITTED = 'Endorsement Submitted',
	ENDORSEMENT_APPROVED_BUT_UNPAID = 'Endorsement Approved but Unpaid',
}

export default EndorsementEligibilityStatusType;